<script>
  import Dashboard from "./Dashboard.svelte";
  import { csvParse, autoType } from "d3-dsv";
  import { onMount } from "svelte";

  let dataCharts = null,
    dataText = null,
    glossary = null;

  async function makeData() {
    const res = await fetch(`./data/datacharts.csv`);
    dataCharts = csvParse(await res.text(), autoType);

    const res2 = await fetch(`./data/datatext.csv`);
    dataText = csvParse(await res2.text(), autoType).map((d) => ({
      ...d,
      enddate: String(d.enddate),
    }));

    const gloss = await fetch(`./data/glossary.csv`);
    glossary = csvParse(await gloss.text(), autoType);

    // console.table(dataText.map((d) => ({ enddate: d.enddate })));
  }

  onMount(makeData);
</script>

{#if dataCharts && dataText && glossary}
  <Dashboard {dataCharts} {dataText} {glossary} />
{/if}
